import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  styled,
  useTheme,
} from "@mui/material";
import { FancyHome, FancyMarket, FancyTrade, FancyWallet } from "assets/Icon";
import { useNavigate, useResolvedPath } from "react-router-dom";

import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import { useMemo } from "react";
import { ROUTE_PATHS } from "routes/paths";

export default function FixedBottomMenu() {
  const theme = useTheme();
  const resolvedPath = useResolvedPath();
  const navigate = useNavigate();
  const isUserBlocked = useIsUserBlocked();

  const value = useMemo(() => {
    const firstPartOfPath = resolvedPath.pathname.split("/")?.[1];

    if (firstPartOfPath) return `/${firstPartOfPath}`;
    else return "/";
  }, [resolvedPath]);

  return (
    <BoxAppBar elevation={3}>
      <BottomNavigation showLabels value={value}>
        <BottomNavigationActionStyle
          label="Home"
          value="/"
          disabled={isUserBlocked}
          onClick={() => navigate("/")}
          icon={<FancyHome color={theme.palette.text.secondary} />}
        />

        <BottomNavigationActionStyle
          label="Market"
          value={ROUTE_PATHS.market}
          onClick={() => navigate(ROUTE_PATHS.market)}
          icon={<FancyMarket color={theme.palette.text.secondary} />}
        />

        <BottomNavigationActionStyle
          label="Trade"
          disabled={isUserBlocked}
          value="/trade"
          onClick={() => navigate(ROUTE_PATHS.trade.basic("1", "3"))}
          icon={<FancyTrade color={theme.palette.text.secondary} />}
        />

        <BottomNavigationActionStyle
          label="Wallet"
          disabled={isUserBlocked}
          value="/wallet"
          onClick={() => navigate("/wallet/spot")}
          icon={<FancyWallet color={theme.palette.text.secondary} />}
        />
      </BottomNavigation>
    </BoxAppBar>
  );
}

const BoxAppBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.modules.appBar,
  boxShadow: "0 -4px 7px rgb(31 53 95 / 19%)",
  borderRadius: "10px 10px 0 0",
  border: " 0.75px solid hsla(0,0%,95.7%,.04)",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,

  ".MuiBottomNavigation-root": {
    background: "none",
    color: theme.palette.modules.appBarItem,
    height: "64px",
    paddingBottom: theme.spacing(1.5),

    ".Mui-selected": {
      color: theme.palette.modules.appBarrActive,

      svg: {
        path: {
          stroke: theme.palette.modules.appBarrActive,
        },
      },
    },

    ".MuiButtonBase-root": {
      padding: theme.spacing(0.75, 1.5, 1),
      maxWidth: "168px",
      minWidth: "80px",
      fontSize: "20px",
    },
  },
}));

const BottomNavigationActionStyle = styled(BottomNavigationAction)(
  ({ theme }) => ({
    padding: `${theme.spacing(1, 1.5, 1.7)} !important`,

    svg: {
      width: "30px",
      height: "30px",
    },

    ".MuiBottomNavigationAction-label": {
      fontSize: "12px !important",
      lineHeight: "0",
      marginTop: theme.spacing(1.2),
    },
  })
);
